import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { FollowButton } from '@sorare/core/src/components/user/FollowButton';

import { UserNetworkInfo } from './UserNetworkInfo';
import type { UserNetwork_user } from './__generated__/index.graphql';

const Root = styled.div`
  border-radius: var(--radius-l);
  overflow: hidden;
  border: 1px solid var(--c-nd-50);
`;

type Props = {
  user: UserNetwork_user & { subscriptionSlug?: string };
};

export const UserNetwork = ({ user }: Props) => {
  return (
    <Root>
      <UserNetworkInfo user={user}>
        <FollowButton
          size="small"
          subscribable={{ slug: user.slug, __typename: 'User' }}
          initialSubscription={user.followed}
        />
      </UserNetworkInfo>
    </Root>
  );
};

UserNetwork.fragments = {
  user: gql`
    fragment UserNetwork_user on PublicUserInfoInterface {
      slug
      followed {
        slug
      }
      ...UserNetworkInfo_publicUserInfoInterface
    }
    ${UserNetworkInfo.fragments.user}
  ` as TypedDocumentNode<UserNetwork_user>,
};
